var map = {
	"./Allotments.svg": 94732,
	"./CSVDoc.svg": 91565,
	"./CancelDark.svg": 21717,
	"./ClosingRank.svg": 25522,
	"./Counselling.svg": 93160,
	"./Counsellings.svg": 25371,
	"./Courses.svg": 48311,
	"./Crown.svg": 7932,
	"./Dashboard.svg": 43189,
	"./ErrorMsg.svg": 91678,
	"./ExclusiveIcon.png": 2578,
	"./FAQs.svg": 27548,
	"./Facebook.svg": 65591,
	"./FeeBond.svg": 16334,
	"./Insta.svg": 34716,
	"./Institute.svg": 2508,
	"./Institutes.svg": 26407,
	"./Location.svg": 38230,
	"./LogoutIcon.svg": 49010,
	"./Matrix.svg": 12344,
	"./MyChoice.svg": 18052,
	"./OldTick.svg": 53,
	"./PDFDoc.svg": 74779,
	"./Premium&Exclusive.png": 9192,
	"./PremiumIcon.png": 38297,
	"./RankScan.svg": 5174,
	"./Ranks.svg": 3944,
	"./Resources.svg": 88978,
	"./Seat.svg": 47876,
	"./SeatIncrease.svg": 13556,
	"./SelectionHat.svg": 85298,
	"./SuccessMsg.svg": 62455,
	"./Tick.svg": 29496,
	"./Twitter.svg": 38912,
	"./Universities.svg": 49579,
	"./Vector.svg": 5274,
	"./Videos.svg": 15331,
	"./WhiteCrown.svg": 42223,
	"./X_Circle.svg": 22560,
	"./YouTube.svg": 66358,
	"./arrow_back.svg": 62312,
	"./arrow_back_ios_new.svg": 39481,
	"./arrow_front.svg": 74018,
	"./bed.svg": 49712,
	"./calendar_month.svg": 67646,
	"./calendarselected.svg": 12422,
	"./cancel.svg": 92045,
	"./check.svg": 82497,
	"./check_Circle.svg": 16008,
	"./close.svg": 35837,
	"./closeicon.svg": 5082,
	"./cross.svg": 9973,
	"./darkFacebook.svg": 40847,
	"./darkInstagram.svg": 33733,
	"./darkQuora.svg": 52903,
	"./darkTelegram.svg": 39222,
	"./darkX.svg": 38593,
	"./darkYoutube.svg": 99246,
	"./dotRed.svg": 21289,
	"./drag.svg": 37229,
	"./drag_indicator.svg": 21211,
	"./edit.svg": 975,
	"./exclusive.png": 12937,
	"./expandIconWhite.svg": 11447,
	"./expand_more.svg": 8605,
	"./expandmore.svg": 80768,
	"./expandmorepurple.png": 78632,
	"./eye.svg": 34426,
	"./eye_off.svg": 46096,
	"./facebookIcon.svg": 92952,
	"./fb.svg": 31167,
	"./google.svg": 3486,
	"./greenTick.svg": 8791,
	"./headerlock.svg": 11849,
	"./iconClose.svg": 33200,
	"./ii_facebook.png": 18972,
	"./ii_instagram.png": 58558,
	"./ii_quora.png": 65132,
	"./ii_x.png": 36186,
	"./ii_youtube.png": 19973,
	"./info.svg": 36947,
	"./instagram.svg": 85373,
	"./instagramIcon.svg": 22298,
	"./instagram_icon.png": 8853,
	"./invalidCross.svg": 32444,
	"./left_arrow.svg": 28622,
	"./linkedinIcon.svg": 63854,
	"./lock.png": 82488,
	"./merit.svg": 8426,
	"./msg.svg": 46930,
	"./navbar_arrow.svg": 87667,
	"./non-veg-fssai.png": 74008,
	"./notifications.svg": 97497,
	"./orangeInfo.svg": 62577,
	"./orangedelete.svg": 80612,
	"./packages.svg": 16772,
	"./password_eye.svg": 36914,
	"./playIcon.svg": 67218,
	"./premium-icon.svg": 86072,
	"./profile.svg": 22030,
	"./profilecalender.svg": 2296,
	"./profiledit.svg": 11373,
	"./quora icon.svg": 69386,
	"./radio_green.svg": 69500,
	"./radio_orange.svg": 84841,
	"./radio_purple.svg": 67053,
	"./right.svg": 42387,
	"./right_arrow.svg": 33581,
	"./search.svg": 64343,
	"./searchicon.svg": 52408,
	"./share.svg": 67300,
	"./shareIcon.svg": 94367,
	"./sort_arrow.svg": 39225,
	"./sort_arrow_orange.svg": 47554,
	"./sort_arrow_orange_low.svg": 43833,
	"./switchdotblue.svg": 12212,
	"./switchdotorange.svg": 98670,
	"./telegram-paper-airplane.png": 73586,
	"./telegram.png": 48624,
	"./telegramIcon.svg": 87533,
	"./thumb_cover.svg": 31529,
	"./thumb_up_fill.svg": 42521,
	"./thumb_up_unfill.svg": 88056,
	"./thumbs_down.svg": 26347,
	"./thumbs_up.svg": 94564,
	"./twitterIcon.svg": 25531,
	"./twitter_icon.png": 94718,
	"./user.png": 42176,
	"./veg-fssai.png": 63722,
	"./videoThumb.svg": 66672,
	"./videolock.svg": 13333,
	"./whatsapp-icon.png": 79197,
	"./whatsapp-logo.png": 75735,
	"./whatsapp-logo.svg": 66823,
	"./whatsapp.svg": 34609,
	"./whatsappIcon.svg": 77070,
	"./withdraw.svg": 12961,
	"./youtube_icon.png": 54244,
	"./zynerd_icon.png": 22191,
	"./zynerdlogo.svg": 57524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;